<template>
  <div>
    <v-tooltip bottom v-if="canManageStructureHere">
      <template v-slot:activator="{ on }">
        <v-icon medium class="mr-2" v-on="on" @click.stop="copyItem(item)"
          >content_copy</v-icon
        >
      </template>
      <span>{{ $t("inspections.category.copy") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="canEditStructureHere">
      <template v-slot:activator="{ on }">
        <v-icon medium class="mr-2" v-on="on" @click.stop="editItem(item)"
          >edit</v-icon
        >
      </template>
      <span>{{ $t("inspections.category.edit") }}</span>
    </v-tooltip>
    <v-tooltip bottom v-if="canManageStructureHere">
      <template v-slot:activator="{ on }">
        <v-icon
          medium
          class="mr-2"
          v-on="on"
          @click.stop="openDeleteDialog(item)"
          >delete</v-icon
        >
      </template>
      <span>{{ $t("inspections.category.delete") }}</span>
    </v-tooltip>
    <deleteDialog
      @triggerDelete="deleteItem"
      :item="item"
      :deleteDialog="deleteDialog"
    />
  </div>
</template>

<script>
import deleteDialog from "../../_utils/dataTableHelpers/actions/deleteDialog.vue";
export default {
  props: ["item"],
  components: { deleteDialog },
  data: () => ({
    deleteDialog: {
      open: false,
      title: "inspections.category.delete",
      description: "",
    },
  }),
  methods: {
    editItem(item) {
      this.$router.push({
        name: "inspectionCategoryForm",
        params: { id: item.id, mode: "edit" },
      });
    },
    copyItem(item) {
      this.$router.push({
        name: "inspectionCategoryForm",
        params: { id: item.id, mode: "copy" },
      });
    },
    openDeleteDialog(item) {
      this.deleteDialog.open = true;
      this.deleteDialog.description = this.$t(
        "inspections.category.deleteLong",
        { name: item.name },
      );
    },
    deleteItem(item) {
      this.$store.dispatch("deleteInspectionCategory", item).then(() => {
        this.$emit("reloadData");
        this.deleteDialog.open = false;
      });
    },
  },
};
</script>
